<template>
    <div
        class="list-group campaigns-list catch-11 mx-4 mb-4  md:mx-8"
        style="margin: 60px 30px 0; border-radius: 0; padding-bottom: 120px; margin-bottom: 15px;"
    >
        <div v-for="(campaign, index) of campaigns" :key="campaign.id" :data-index="index">
            <div
                v-if="index > 0"
                style="border-bottom: 1px solid #1825d8;width: calc(100% + 60px);margin-left: -30px;margin-bottom: 30px;margin-top: 10px;"
            ></div>

            <div class="flex flex-wrap md:flex-nowrap justify-center md:justify-start">
                <div
                    class="w-40 h-40 md:mx-8 mb-5 flex-none"
                    :style="{
                        'background-color': '#00000029',
                        'background-position': 'center',
                        'background-size': '160px',
                        'background-image': 'url(' + campaign.image_url + ')',
                    }"
                ></div>

                <div class="flex-auto">
                    <div class="flex justify-between relative pr-[150px] md:pr-0 gap-5">
                        <h3
                            v-text="campaign.name"
                            class="font-bold text-lg not-italic text-indigo-700 text-left"
                        ></h3>
                        <a
                            class="absolute top-0 right-0 py-1 px-3 md:static bg-indigo-700 text-white uppercase font-semibold flex-none h-fit

"
                            :href="'/campaigns/' + campaign.id"
                            >Se detaljer</a
                        >
                    </div>

                    <div class="text-left mt-2 mb-2 font-bold text-lg">
                        <span v-if="campaign.status === 'published'" style="color: #66DBA8;"
                            >Aktiv</span
                        >
                        <span v-else-if="campaign.status === 'expired'" style="color: #FC0403;"
                            >Udløbet</span
                        >
                        <span v-else-if="campaign.status === 'draft'" style="color: #707070"
                            >Kladde</span
                        >
                        <span v-else style="color: #707070;">Ukendt Status</span>
                    </div>

                    <div class="flex gap-3 text-[#1825D8]">
                        <div class="flex w-1/2">
                            <div class="text-3xl md:text-5xl mr-5">
                                <span :class="campaign.platform.icon"></span>
                            </div>
                            <div class="text-left md:mt-4">
                                <h5 style="color: #1825D8; font-size: 16px;">Est. rækkevidde</h5>
                                <span
                                    class="lead"
                                    v-text="campaign.reach_achieved"
                                    style="color: #1825D8; font-size: 16px;"
                                ></span>
                            </div>
                        </div>
                        <div class="text-right w-1/2 md:mt-4">
                            <h5 style="color: #1825D8; font-size: 16px;">Est. rækkevidde</h5>
                            <span
                                class="lead"
                                v-text="campaign.reach_achieved"
                                style="color: #1825D8; font-size: 16px;"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>

            <!--
            <div class="text-right">
                <campaign-status :campaign="campaign"></campaign-status>
            </div>

            <div class="flex v-center">
                <div class="flex-1">
                    <h3 v-text="campaign.name"></h3>

                    <div class="row m-t-lg m-b-lg">
                        <div class="col-xs-6">
                            <h5>Est. rækkevidde</h5>
                            <span class="lead" v-text="campaign.reach_achieved"></span>
                        </div>

                        <div class="col-xs-6">
                            <h5>Forbrugt budget</h5>
                            <span class="lead">
                                <amount :value="campaign.budget_spent"></amount>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="p-sm">
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>
            -->
        </div>
    </div>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import CampaignCard from 'dashboard-js/components/campaigns/CampaignCard'

export default {
    components: { CampaignCard },

    props: ['campaigns'],
}
</script>
